// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2-88E","containerItemsCenter":"Skeleton_containerItemsCenter__ej83b"};